import { Formik, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import "./index.css"; // Create this CSS file
import { CreateSubAdminSchema } from "../../../Services/schema";
import AccountService from "../../../Services/AccountService";
import { useAuth } from "../../../Utils/Auth";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import FullScreenLoader from "../../../Component/FullScreenLoader";
import adminService from "../../../Services/apiService/admin-service";
import AdminPermission from "../../../Component/edit_permission/admin_permission";

const CreateAdmin = () => {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [fieldValues , setFieldValue] = useState([])
  const initialValues = {
    firstName: "",
    lastName: "",
    userName: "",
    password: "",
    roles: ["Dashboard-View"],
  };

  const handleSubmit = (values, { resetForm }) => {
    values.roles = [...values.roles ,...fieldValues]
    setIsLoading(true);
    adminService.createAdmin(values, auth.user)
      .then((res) => {
        toast.success(toTitleCase(res.data.message));
        resetForm();
        setFieldValue([])
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(toTitleCase(customErrorHandler(err)));
      });
  };

  // const roles = [
  //   "Dashboard-View",
  //   "Report-All-Txn",
  //   "Report-My-Txn",
  //   "Create-Transaction",
  //   "Bank-View",
  //   "Create-User",
  //   "Website-View",
  //   "Introducer-Profile-View",
  //   "Request-Admin",
  //   "RecycleBin-View",
  //   "Transaction-Delete-Request",
  //   "User-Profile-View",
  //   "Profile-View",
  //   "Create-Withdraw-Transaction",
  //   "Create-Deposit-Transaction",
  //   "Create-Introducer",
  //   "Report-Admin",
  // ];

  return (
    <Container fluid className="admin-container">
      <FullScreenLoader show={isLoading} />
      <Row className="justify-content-center ">
        <Col xl={10} lg={12}>
          <Card className="admin-card">
            <Card.Body>
              <h2 className="admin-title">Create New Subadmin</h2>
              <Formik
                initialValues={initialValues}
                validationSchema={CreateSubAdminSchema}
                onSubmit={handleSubmit}
              >
                {({ values, handleChange , errors, touched , handleSubmit}) => (
                  <Form>
                    <Row className="g-3">
                      {/* User Name */}
                      <Col md={6}>
                        <Form.Group controlId="userName">
                          <Form.Label>
                            Username <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as={Form.Control}
                            type="text"
                            name="userName"
                            placeholder="Enter Username"
                            isInvalid={touched.userName && errors.userName}
                          />
                          <ErrorMessage
                            name="userName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Form.Group>
                      </Col>

                      {/* Password */}
                      <Col md={6}>
                        <Form.Group controlId="password">
                          <Form.Label>
                            Password <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as={Form.Control}
                            type="password"
                            name="password"
                            placeholder="Create Password"
                            isInvalid={touched.password && errors.password}
                          />
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Form.Group>
                      </Col>

                      {/* First Name */}
                      <Col md={6}>
                        <Form.Group controlId="firstName">
                          <Form.Label>
                            First Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as={Form.Control}
                            type="text"
                            name="firstName"
                            placeholder="Enter First Name"
                            isInvalid={touched.firstName && errors.firstName}
                          />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Form.Group>
                      </Col>

                      {/* Last Name */}
                      <Col md={6}>
                        <Form.Group controlId="lastName">
                          <Form.Label>
                            Last Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as={Form.Control}
                            type="text"
                            name="lastName"
                            placeholder="Enter Last Name"
                            isInvalid={touched.lastName && errors.lastName}
                          />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Form.Group>
                      </Col>

                      {/* Roles Section */}
                      {/* <Col xs={12}>
                        <Card className="roles-card">
                          <Card.Body>
                            <h5 className="roles-title">Admin Permissions</h5>
                            <Row className="g-2">
                              {roles.map((role) => (
                                <Col key={role} md={4} sm={6}>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={role}
                                      name="roles"
                                      value={role}
                                      checked={values.roles.includes(role)}
                                      onChange={(e) => {
                                         if (role === "Dashboard-View" && !e.target.checked) return;
                                        const { checked, value } = e.target;
                                        const updatedRoles = checked
                                          ? [...values.roles, value]
                                          : values.roles.filter(
                                              (r) => r !== value
                                            );
                                        setFieldValue("roles", updatedRoles);
                                      }}
                                      isInvalid={touched.roles && errors.roles}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={role}
                                    >
                                      {role.replace(/-/g, " ")}
                                    </label>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Card.Body>
                          <ErrorMessage
                            name="roles"
                            component="div"
                            className="invalid-feedback text-center"
                          />
                        </Card>
                      </Col> */}
                      <Col xs={12}>
                        <AdminPermission
                          selectedRoles={fieldValues}
                          setSelectedRoles={setFieldValue}
                        />
                      </Col>
                      

                      {/* Submit Button */}
                      <Col xs={12} className="mt-4">
                        <div className="d-grid">
                          <Button
                            variant="primary"
                            type="submit"
                            size="lg"
                            className="submit-btn mb-3"
                            onClick={handleSubmit}
                          >
                            CREATE ADMIN
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CreateAdmin;
